<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';

const props = defineProps({ appointment: { type: Object, required: true } });
const store = useStore();
const { t } = useI18n();

const status = computed(() => props.appointment.google_sync_status);
const tooltip = computed(() => {
  if (status.value === 'failed')
    return (
      props.appointment.google_sync_error ||
      t('PAINEL.SYNC_STATUS.TOOLTIP_FAILED')
    );
  if (status.value === 'disconnected')
    return t('PAINEL.SYNC_STATUS.TOOLTIP_DISCONNECTED');
  return null;
});

const retry = () =>
  store.dispatch('painelAppointments/retrySync', props.appointment.id);
</script>

<template>
  <div>
    <button
      v-if="status === 'failed' || status === 'disconnected'"
      :title="tooltip"
      :aria-label="tooltip"
      class="inline-flex h-5 w-5 items-center justify-center rounded-full bg-amber-100 text-amber-700"
      @click.stop="retry"
    />
  </div>
</template>
